<template>
  <confirmationModal
    v-bind="$attrs"
    v-on="$listeners"
    title="Confirm Restore"
    @closeModal="closeModal"
  >
    <p class="subtitle-1">Are you sure you want to restore this change?</p>
    <commitData
        @setIsFormValid="setIsFormValid"
        @setTitle="setTitle"
        @setDetails="setDetails"
      />
    <template #buttons>
      <qvoButton text @click="closeModal">Cancel</qvoButton>
      <qvoButton @click="restoreChange" :disabled="!isFormValid"
        >Confirm Restore</qvoButton
      >
    </template>
  </confirmationModal>
</template>
    
<script>
import qvoButton from "@/qux-common/qux22/components/molecules/button";

import commitData from "@/components/commit-data";
import confirmationModal from "@/components/confirmation-modal";

export default {
  name: "RestoreConfirmationModal",
  components: {
    commitData,
    confirmationModal,
    qvoButton,
  },
  data() {
    return {
      isFormValid: false,
      details: undefined,
      title: undefined,
    };
  },
  methods: {
    setIsFormValid(value) {
      this.isFormValid = value;
    },
    setTitle(title) {
      this.title = title;
    },
    setDetails(details) {
      this.details = details;
    },
    restoreChange() {
      this.$emit("restoreChange", {
        ChangeTitle: this.title,
        ChangeDetails: this.details,
      });
      this.closeModal();
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
    
<style lang="scss" scoped>
.commit-data {
  margin-top: $qvo-spacing-24;
}
</style>